/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from "react";
import { requestGetUniversitySpaces } from "services/resources/universitySpaces/aboutUniversitySpaceResources";
import { QUANTITY_PER_PAGE } from "views/components/Schedules/utils/constants";
import { SPACE_RESERVATIONS_KEYS } from "../constants";

const useSpaceList = ({
    filters,
    utils: {
        loadingRequestOfGrid,
        toastMessage
    },
    fatalError,
    paginator, isCampusCoordinator
}) => {
    //#region States
    const [spaceList, setSpaceList] = useState(null);
    const [triggerRequest, setTriggerRequest] = useState(false);
    //#endregion
    //#region Effects
    useEffect(() => {
        if (!isCampusCoordinator) return;
        filters.appliedFilters.apply({ 
            campusId: filters.value.campusId
        });
    }, [filters.value.campusId]);
    useEffect(() => {
        if (!triggerRequest) return;
        setTriggerRequest(false);
        fillSpaceList();
    }, [triggerRequest]);
    //#endregion
    //#region Functions
    async function fillSpaceList(params) {
        const { messageForToast, noFill } = params || { messageForToast: null, noFill: false };
        if (noFill) {
            loadingRequestOfGrid.hide();
            showToastAfterFilledSpaceList(messageForToast);
            return;
        }
        loadingRequestOfGrid.show();
        // Realizando petición
        const newPage = filters.haveBeenApplied() ? 1 : paginator.data.currentPage;
        const data = await requestGetUniversitySpaces({
            ...filters.value,
            page: newPage
        });
        loadingRequestOfGrid.hide();
        if (!data) {
            fatalError.notify();
            return;
        }
        filters.appliedFilters.applyAllFilters({
            page: newPage
        });
        const { resources, total } = data;
        updatePaginator(newPage, total);
        // Setteando lista de servicios
        setSpaceList(resources);
        showToastAfterFilledSpaceList(messageForToast);
    }
    async function removeSpaceFromList(spaceId) {
        setSpaceList(prev => prev.filter(spaceItem =>
            spaceItem.space.id !== spaceId
        ));
    }
    function updateSpaceFromList(newSpace) {
        if (!newSpace)
            throw new Error("Space to update not exists");
        if (!spaceList)
            throw new Error("Space list is empty");
        setSpaceList(prev => prev.map(spaceItem =>
            spaceItem.space.id === newSpace.id
                ? {
                    ...spaceItem,
                    space: newSpace
                } : spaceItem
        ));
    }
    function updatePaginator(newPage, total) {
        paginator.movePage(newPage);
        paginator.setQuantityPages({
            quantityPages: Math.ceil(total / QUANTITY_PER_PAGE),
            totalRecords: total
        });
    }
    function clearSpaceList() {
        setSpaceList(null);
    }
    async function showToastAfterFilledSpaceList(message) {
        if (!message) return;
        // Configurando toast de carga exitosa
        toastMessage.show(message, null);
    }
    function updateReservationFromSpaceList(newReservation, reservationType) {
        const reservationsKey = SPACE_RESERVATIONS_KEYS[reservationType];
        if (!reservationsKey) return;
        setSpaceList(prev => prev.map(spaceItem =>
            spaceItem.space.id === newReservation.space.id
                ? {
                    ...spaceItem,
                    [reservationsKey]: spaceItem[reservationsKey].map(reservation => (
                        reservation.id === newReservation.id
                            ? newReservation
                            : reservation
                    ))
                } : spaceItem
        ));
    }
    function removeReservationFromSpaceList(reservationToRemove, reservationType) {
        const reservationsKey = SPACE_RESERVATIONS_KEYS[reservationType];
        if (!reservationsKey) return;
        setSpaceList(prev => prev.map(spaceItem =>
            spaceItem.space.id === reservationToRemove.space.id
                ? {
                    ...spaceItem,
                    [reservationsKey]: spaceItem[reservationsKey]
                        .filter(reservation => reservation.id !== reservationToRemove.id)
                } : spaceItem
        ));
    }
    function isEmptySpaceList() {
        return spaceList?.length === 0;
    }
    //#endregion
    return {
        triggerFilling: () => setTriggerRequest(true),
        fill: fillSpaceList,
        clear: clearSpaceList,
        value: spaceList,
        isEmpty: isEmptySpaceList,
        updateSpace: updateSpaceFromList,
        removeSpace: removeSpaceFromList,
        reservations: {
            update: updateReservationFromSpaceList,
            remove: removeReservationFromSpaceList
        }
    };
}

export default useSpaceList;